import { BaseApiService } from "@mirage/services/BaseApiService";
import { IConsulteeService } from "@shared/publicportal/services/IConsulteeService";
import { VerifyConsulteeResult, VerifyRequest } from "@shared/mirage/core/contracts/User";

export class ConsulteeService extends BaseApiService implements IConsulteeService {
    constructor() {
        super("publicportal/consultee");
    }

    async verifyConsultee(request: VerifyRequest): Promise<VerifyConsulteeResult> {
        const response = await this.httpInstance().post("/verifyconsultee", request);
        return response.data;
    }
}
